<template>
  <div>
    <div class="white-wrapper description mt-3">
      <h5 class="mb-3 font-weight-bold border-bottom pb-2">
        <img src="https://vk.com/emoji/e/e2ad90_2x.png" class="title-icon"/>
        Предсказания на день
      </h5>

      <div class="mobile-items">
        <div class="description__item" v-for="item in items" :key="item['title']" @click="showMoonCategoryInfo(item)">
          <div class="description__item-text">
            <img class="icon" :src="item['iconLarge']"/> <b>{{ item['title'] }}</b>. {{ item['textShort'] }}
          </div>

          <div class="description__item-arrow">
            <svg width="12px" height="16px" viewBox="0 0 12 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink">
              <title>chevron_16</title>
              <desc>Created with Sketch.</desc>
              <defs></defs>
              <g id="Page-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="chevron_16">
                  <rect id="Bounds" x="0" y="0" width="12" height="16"></rect>
                  <path
                      d="M7.2272139,8 L3.86361,4.6363961 C3.51213814,4.28492424 3.51213814,3.71507576 3.86361,3.3636039 C4.21508186,3.01213203 4.78493034,3.01213203 5.13640221,3.3636039 L9.13640221,7.3636039 C9.48787407,7.71507576 9.48787407,8.28492424 9.13640221,8.6363961 L5.13640221,12.6363961 C4.78493034,12.987868 4.21508186,12.987868 3.86361,12.6363961 C3.51213814,12.2849242 3.51213814,11.7150758 3.86361,11.3636039 L7.2272139,8 Z"
                      id="Mask" fill="currentColor" fill-rule="nonzero"></path>
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div>

      <div class="desktop-items">
        <div class="my-2" v-for="item in items" :key="item['title']">
          <span class="font-weight-bold">
            <img class="icon" :src="item['iconLarge']"/> {{ item['title'] }}.
          </span>
          {{ item['textFull'] }}
        </div>
      </div>
    </div>

    <div class="description__subscribe">
      <div v-if="! isSubscribed && ! isSubscribeInProcess && ! errorSubscribe" class="description__subscribe_wrapper"
           @click="subscribeToMessage">
        <svg height="28px" version="1.1" viewBox="0 0 28 28" width="28px" xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Page-1" fill="none" fill-rule="evenodd" stroke="none" stroke-width="1">
            <g id="notification_outline_28">
              <rect height="28" width="28" x="0" y="0"></rect>
              <path
                  id="↳-Icon-Color"
                  d="M14.0046028,3.5 C18.5358601,3.5 22,7.29406785 22,12.0814651 L21.9953979,13.9081084 C21.9958228,14.2153952 22.1945877,14.5706814 22.7335216,15.2049931 C22.8012144,15.2846658 22.8649419,15.3585239 23.0042724,15.5194663 C24.0744404,16.7576538 24.5,17.4744714 24.5,18.5882353 C24.5,19.0892946 24.4430332,19.4785282 24.2055926,19.9455699 C23.69956,20.9409276 22.6182188,21.5 21,21.5 L18.3988532,21.5006982 C17.7309515,23.7645264 16.2123212,24.9999999 14,24.9999999 C11.7876788,24.9999999 10.2690485,23.7645264 9.6011468,21.5006982 L7,21.5 C5.33483077,21.5 4.24202957,20.9258124 3.75797492,19.8962478 C3.54802005,19.4496823 3.5,19.0874607 3.5,18.5882353 C3.5,17.4749766 3.92475347,16.7581996 4.9928315,15.520155 C5.13190601,15.3592125 5.19551502,15.285356 5.26308201,15.205685 C5.80170622,14.5705706 6,14.215121 6,13.9071207 L6,12.0789474 C6,7.29571186 9.47202448,3.5 14.0046028,3.5 Z M16.2794024,21.5008013 L11.7205976,21.5008013 C12.1713889,22.5431725 12.8986588,23.0000001 14,23.0000001 C15.1013412,23.0000001 15.8286111,22.5431725 16.2794024,21.5008013 Z M14.0046028,5.5 C10.6183529,5.5 8,8.3624548 8,12.0789474 L8,13.9071207 C8,14.8348489 7.61560159,15.5238985 6.78840913,16.4992758 C6.71508593,16.5857342 6.64587176,16.6660989 6.5071685,16.8265942 C5.74712153,17.7075898 5.5,18.1246106 5.5,18.5882353 C5.5,18.8143528 5.51596919,18.9348106 5.56791451,19.0452961 C5.69184037,19.3088814 6.05557968,19.5 7,19.5 L21,19.5 C21.9142367,19.5 22.2862841,19.3076449 22.4227634,19.0391925 C22.4818467,18.9229767 22.5,18.7989414 22.5,18.5882353 C22.5,18.1251158 22.2524476,17.7081357 21.4911248,16.8272829 C21.3521661,16.6667875 21.2828259,16.5864244 21.2093691,16.4999676 C20.3805492,15.5244674 19.9953972,14.8353358 19.9953972,13.9071207 L20,12.0789474 C20,8.36007608 17.388633,5.5 14.0046028,5.5 Z"
                  fill="currentColor" fill-rule="nonzero"></path>
            </g>
          </g>
        </svg>
        <span>Подписаться на ежедневные предсказания</span>
      </div>

      <div v-if="isSubscribed && ! isSubscribeInProcess && ! errorSubscribe" class="description__subscribe_wrapper"
           @click="unsubscribeToMessage">
        <svg height="28px" version="1.1" viewBox="0 0 28 28" width="28px" xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Page-1" fill="none" fill-rule="evenodd" stroke="none" stroke-width="1">
            <g id="notification_disable_outline_28">
              <rect height="28" width="28" x="0" y="0"></rect>
              <path
                  id="↳-Icon-Color"
                  d="M4.29289322,4.29289322 C4.68341751,3.90236893 5.31658249,3.90236893 5.70710678,4.29289322 L5.70710678,4.29289322 L24.0918831,22.6776695 C24.4824074,23.0681938 24.4824074,23.7013588 24.0918831,24.0918831 C23.7013588,24.4824074 23.0681938,24.4824074 22.6776695,24.0918831 L22.6776695,24.0918831 L20.0818157,21.4967012 C20.0548323,21.4988862 20.0275462,21.5 20,21.5 L18.3988532,21.5006982 C17.7309515,23.7645264 16.2123212,24.9999999 14,24.9999999 C11.7876788,24.9999999 10.2690485,23.7645264 9.6011468,21.5006982 L7,21.5 C5.33483077,21.5 4.24202957,20.9258124 3.75797492,19.8962478 C3.54802005,19.4496823 3.5,19.0874607 3.5,18.5882353 C3.5,17.4749766 3.92475347,16.7581996 4.9928315,15.520155 C5.13190601,15.3592125 5.19551502,15.285356 5.26308201,15.205685 C5.80170622,14.5705706 6,14.215121 6,13.9071207 L6,12.0789474 C6,10.7185687 6.28259935,9.4095819 6.81846161,8.23409397 L4.29289322,5.70710678 C3.90236893,5.31658249 3.90236893,4.68341751 4.29289322,4.29289322 Z M16.2794024,21.5008013 L11.7205976,21.5008013 C12.1713889,22.5431725 12.8986588,23.0000001 14,23.0000001 C15.1013412,23.0000001 15.8286111,22.5431725 16.2794024,21.5008013 Z M14.0046028,3.5 C18.5358601,3.5 22,7.29406785 21.9999968,12.0814651 L21.9953972,13.9071207 C21.9953972,14.2146342 22.1940102,14.5700017 22.7335216,15.2049931 C22.8012144,15.2846658 22.8649419,15.3585239 23.0042724,15.5194663 C23.8083681,16.4498073 24.1667405,16.9696046 24.3798237,17.7274431 C24.4589197,18.0087509 24.5,18.2955297 24.5,18.5882353 C24.5,19.14052 24.0522847,19.5882353 23.5,19.5882353 C22.9477153,19.5882353 22.5,19.14052 22.5,18.5882353 C22.5,18.4821958 22.4849559,18.3771742 22.4544829,18.2687958 C22.3480667,17.8903225 22.1042135,17.5366283 21.4911248,16.8272829 C21.3521661,16.6667875 21.2828259,16.5864244 21.2093691,16.4999676 C20.3805492,15.5244674 19.9953972,14.8353358 19.9954004,13.9046031 L20,12.0789474 C20,8.36007608 17.388633,5.5 14.0046028,5.5 C12.9499008,5.5 11.9579208,5.77343853 11.0852647,6.29010234 C10.6100276,6.57147069 9.99667773,6.41430902 9.71530938,5.93907193 C9.43394103,5.46383483 9.5911027,4.85048493 10.0663398,4.56911658 C11.2464932,3.87039624 12.5902163,3.5 14.0046028,3.5 Z M18.086,19.5 L8.36064774,9.77566958 C8.12386309,10.4985445 8,11.2750416 8,12.0789474 L8,13.9071207 C8,14.8348489 7.61560159,15.5238985 6.78840913,16.4992758 C6.71508593,16.5857342 6.64587176,16.6660989 6.5071685,16.8265942 C5.74712153,17.7075898 5.5,18.1246106 5.5,18.5882353 C5.5,18.8143528 5.51596919,18.9348106 5.56791451,19.0452961 C5.69184037,19.3088814 6.05557968,19.5 7,19.5 L18.086,19.5 Z"
                  fill="currentColor" fill-rule="nonzero"></path>
            </g>
          </g>
        </svg>

        <span>Отписаться от ежедневных предсказаний</span>
      </div>

      <div v-if="errorSubscribe && ! isSubscribeInProcess" class="description__subscribe_wrapper">
        <svg height="28px" style="cursor: default" version="1.1" viewBox="0 0 28 28" width="28px"
             xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Page-1" fill="none" fill-rule="evenodd" stroke="none" stroke-width="1">
            <g id="cancel_outline_28">
              <rect height="28" width="28" x="0" y="0"></rect>
              <path
                  id="↳-Icon-Color"
                  d="M6.29289322,6.29289322 C6.68341751,5.90236893 7.31658249,5.90236893 7.70710678,6.29289322 L7.70710678,6.29289322 L14,12.585 L20.2928932,6.29289322 C20.6533772,5.93240926 21.2206082,5.90467972 21.6128994,6.20970461 L21.7071068,6.29289322 C22.0976311,6.68341751 22.0976311,7.31658249 21.7071068,7.70710678 L21.7071068,7.70710678 L15.415,14 L21.7071068,20.2928932 C22.0675907,20.6533772 22.0953203,21.2206082 21.7902954,21.6128994 L21.7071068,21.7071068 C21.3165825,22.0976311 20.6834175,22.0976311 20.2928932,21.7071068 L20.2928932,21.7071068 L14,15.415 L7.70710678,21.7071068 C7.34662282,22.0675907 6.77939176,22.0953203 6.38710056,21.7902954 L6.29289322,21.7071068 C5.90236893,21.3165825 5.90236893,20.6834175 6.29289322,20.2928932 L6.29289322,20.2928932 L12.585,14 L6.29289322,7.70710678 C5.93240926,7.34662282 5.90467972,6.77939176 6.20970461,6.38710056 Z"
                  fill="currentColor" fill-rule="nonzero"></path>
            </g>
          </g>
        </svg>

        <span>Произошла ошибка! Попробуйте позже.</span>
      </div>

      <spinner v-if="isSubscribeInProcess"/>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import bridge from '@vkontakte/vk-bridge';
import {store} from "@/store";
import client from "@/services/client";
import config from "@/config";
import stringHelper from "@/lib/string";

import Spinner from "@/components/_Utlis/Spinner";

export default {
  name: "MoonPredictions",
  components: {Spinner},
  data() {
    return {
      isLoading: true,
      isSubscribeInProcess: false,
      isSubscribed: false,
      errorSubscribe: false,
      items: [],
    }
  },
  mounted() {
    this.checkSubscribe();
    this.setDescriptionItem();
  },
  methods: {
    subscribeToMessage() {
      this.isSubscribeInProcess = true;

      bridge.send("VKWebAppAllowMessagesFromGroup", {
        "group_id": config["group_id"],
      }).then(() => {
        let endpoint = config["endpoint"] + "/api/set-subscribe";
        const state = store.state;
        let params = {
          'user_vk_id': parseInt(state.launchParams["vk_user_id"]),
          'url': state.launchURL
        };
        this.isSubscribed = true;
        // localStorage.userEventSubscribe = state.launchParams["vk_user_id"];

        axios.post(endpoint, params).then(() => {
          this.isSubscribeInProcess = false;
        }).catch(() => {
          this.isSubscribed = false;
          this.errorSubscribe = true;
          this.isSubscribeInProcess = false;
        });

      }).catch(() => {
        this.isSubscribed = false;
        this.isSubscribeInProcess = false;
      });

      bridge.subscribe(({detail: {type}}) => {
        if (type === 'VKWebAppAllowMessagesFromGroupFailed') {
          this.isSubscribed = false;
          this.isSubscribeInProcess = false;
        }
      });
    },
    unsubscribeToMessage() {
      let endpoint = config["endpoint"] + "/api/delete-subscribe";
      const state = this.$store.state;
      let params = {
        'user_vk_id': parseInt(state.launchParams["vk_user_id"]),
        'url': state.launchURL
      };

      this.isSubscribeInProcess = true;
      axios.post(endpoint, params).then(() => {
        // localStorage.userEventSubscribe = null;
        this.isSubscribed = false;
        this.isSubscribeInProcess = false;
      }).catch(() => {
        this.isSubscribed = true;
        this.errorSubscribing();
      });
    },
    checkSubscribe() {
      let endpoint = config["endpoint"] + "/api/check-subscribe";
      const state = this.$store.state;
      let params = {
        'user_vk_id': parseInt(state.launchParams["vk_user_id"]),
        'url': state.launchURL
      };

      this.isSubscribeInProcess = true;
      axios.post(endpoint, params).then((result) => {
        const response = result['data']['response'];
        this.isSubscribed = response;
        this.isSubscribeInProcess = false;
      }).catch(() => {
        this.isSubscribed = false;
        this.isSubscribeInProcess = false;
        this.errorSubscribing();
      });
    },
    errorSubscribing() {
      this.errorSubscribe = true;
      this.isSubscribeInProcess = false;
    },
    setDescriptionItem() {
      this.items.push({
        title: "Дела",
        slug: "buisness",
        textShort: this.moonInfo["buisness"].slice(0, 100) + "...",
        textFull: this.moonInfo["buisness"],
        iconSmall: "https://vk.com/emoji/e/f09f92bc.png",
        iconLarge: "https://vk.com/emoji/e/f09f92bc_2x.png",
      });

      this.items.push({
        title: "Работа",
        slug: "work",
        textShort: this.moonInfo["work"].slice(0, 100) + "...",
        textFull: this.moonInfo["work"],
        iconSmall: "https://vk.com/emoji/e/f09f9ba0.png",
        iconLarge: "https://vk.com/emoji/e/f09f9ba0_2x.png",
      });

      this.items.push({
        title: "Домашние дела",
        slug: "home",
        textShort: this.moonInfo["home"].slice(0, 100) + "...",
        textFull: this.moonInfo["home"],
        iconSmall: "https://vk.com/emoji/e/f09f8fa0.png",
        iconLarge: "https://vk.com/emoji/e/f09f8fa0_2x.png",
      });

      this.items.push({
        title: "Деньги",
        slug: "money",
        textShort: this.moonInfo["money"].slice(0, 100) + "...",
        textFull: this.moonInfo["money"],
        iconSmall: "https://vk.com/emoji/e/f09f919b.png",
        iconLarge: "https://vk.com/emoji/e/f09f919b_2x.png",
      });

      // this.items.push({
      //   title: "Любовь",
      //   slug: "love",
      //   textShort: this.moonInfo["love"].slice(0, 100) + "...",
      //   textFull: this.moonInfo["love"],
      //   iconSmall: "https://vk.com/emoji/e/f09f928c.png",
      //   iconLarge: "https://vk.com/emoji/e/f09f928c_2x.png",
      // });

      this.items.push({
        title: "Общение",
        slug: "communication",
        textShort: this.moonInfo["communication"].slice(0, 100) + "...",
        textFull: this.moonInfo["communication"],
        iconSmall: "https://vk.com/emoji/e/e29c8d.png",
        iconLarge: "https://vk.com/emoji/e/e29c8d_2x.png",
      });

      this.items.push({
        title: "Путешествия",
        slug: "travel",
        textShort: this.moonInfo["travel"].slice(0, 100) + "...",
        textFull: this.moonInfo["travel"],
        iconSmall: "https://vk.com/emoji/e/f09fa7b3.png",
        iconLarge: "https://vk.com/emoji/e/f09fa7b3_2x.png",
      });

      this.items.push({
        title: "Стрижка",
        slug: "hair",
        textShort: this.moonInfo["hair"].slice(0, 100) + "...",
        textFull: this.moonInfo["hair"],
        iconSmall: "https://vk.com/emoji/e/f09f9288.png",
        iconLarge: "https://vk.com/emoji/e/f09f9288_2x.png",
      });

      this.items.push({
        title: "Красота и здоровье",
        slug: "health",
        textShort: this.moonInfo["health"].slice(0, 100) + "...",
        textFull: this.moonInfo["health"],
        iconSmall: "https://vk.com/emoji/e/f09f928a.png",
        iconLarge: "https://vk.com/emoji/e/f09f928a_2x.png",
      });
    },
    showMoonCategoryInfo(category) {
      this.$root.$emit('showMoonCategoryInfo', category);
    },
    generateText(text) {
      return stringHelper.generateText(text);
    }
  },
  computed: {
    moonInfo() {
      return store.state.moonDayInfo["description_category"];
    },
    isMobile() {
      return client.isMobile();
    }
  }
}
</script>

<style lang="scss" scoped>
.title-icon {
  width: 16px;
  height: auto;
  margin-top: -3px;
}

.icon {
  width: 16px;
  height: auto;
  margin-top: -2px;
  margin-right: 2px;
}

.description {
  align-items: center;
  border-radius: .5rem .5rem 0 0 !important;
  @media screen and (max-width: 576px) {
    //padding: 5px 10px !important;
  }
}

.description__item {
  display: flex;
  flex-direction: row;
  padding-bottom: 7px;
  margin-bottom: 7px;

  &:last-of-type {
    margin: 0;
  }
}

.description__item-text {
  @media screen and (min-width: 576px) {
    font-size: 14px;
  }
}

.description__item-arrow {
  display: flex;
  align-items: center;

  & svg {
    color: #ddd;
  }
}

.description-already-done {
  border-radius: .5rem !important;
}

.description__subscribe {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  color: var(--bottom-action-color);
  text-align: center;
  padding: 15px;
  border-radius: 0 0 .5rem .5rem;
  border-bottom: 1px solid var(--bottom-action-border-color);
  border-left: 1px solid var(--bottom-action-border-color);
  border-right: 1px solid var(--bottom-action-border-color);

  @media screen and (max-width: 600px) {
    height: 80px;
  }

  @media screen and (max-width: 350px) {
    height: 95px;
  }

  & svg, & span {
    cursor: pointer;
  }

  & svg {
    margin-top: -2px;
    margin-right: 5px
  }
}

.description__subscribe-already-done {
  display: none;
}

.description__subscribe-done {
  cursor: default !important;
  @media (hover: hover) {
    &:hover {
      text-decoration: none;
    }
  }
}

.description__subscribe_wrapper {
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 600px) {
    flex-direction: column;
  }
}

.mobile-items {
  @media screen and (min-width: 629px) {
    display: none;
  }
  @media screen and (max-width: 629px) {
    display: block;
  }
}

.desktop-items {
  @media screen and (min-width: 629px) {
    display: block;
  }
  @media screen and (max-width: 629px) {
    display: none;
  }
}
</style>